export default function() {
  const widgetName = 'imageWidget';
  const widgetOpts = imageWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: ''
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      function randomize() {
        var cards = [];

        function shuffleArray(array) {
          for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
          }
          return array;
        }

        $('#imageWidget .owl-item').each(function() {
          var widgetItem = $(this).find('.card-widget-item');
          cards.push(widgetItem);
          widgetItem.remove();
        });

        shuffleArray(cards);

        $('#imageWidget .owl-item').each(function(i){
          $(this).append(cards[i]);
        });
      }

      randomize();
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 0,
    moreButton: {
      visible: false,
      text: ''
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: true, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 0,
      nav: false,
      dots: false,
    },
    textOverImage: false
  });
}